export const SearchSvg = (props: any) => {
  return (
    <svg
      {...props}
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.0594 20L15.6844 15.506L20.0594 20ZM18.1089 9.5C18.1089 11.7543 17.2355 13.9163 15.6809 15.5104C14.1263 17.1045 12.0178 18 9.8193 18C7.62076 18 5.51227 17.1045 3.95766 15.5104C2.40306 13.9163 1.52969 11.7543 1.52969 9.5C1.52969 7.24566 2.40306 5.08365 3.95766 3.48959C5.51227 1.89553 7.62076 1 9.8193 1C12.0178 1 14.1263 1.89553 15.6809 3.48959C17.2355 5.08365 18.1089 7.24566 18.1089 9.5V9.5Z"
        stroke="#9299BE"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  )
}
